import React from "react";
import { Helmet } from "react-helmet-async";

type StructuredDataProps = {
  data: object | object[];
};

const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default StructuredData;

